'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('ifeis.adjudicators', []).factory('fAdjudicatorService', function ($http) {
  var prefix = IFEIS_API_URI + '/api/adjudicators';

  /**
   * Adjudicators
   */

  function get() {
    return $http.get(prefix);
  }

  function one(uuid) {
    return $http.get(prefix + '/' + uuid);
  }

  function create(adjudicator) {
    return $http.post(prefix, adjudicator);
  }

  function update(adjudicator) {
    return $http.put(prefix + '/' + adjudicator.id, adjudicator);
  }

  function remove(uuid) {
    return $http.delete(prefix + '/' + uuid);
  }

  /**
   * Exported API
   */

  return {
    get: get,
    one: one,
    create: create,
    remove: remove,
    update: update
  };
});


//////////////////
// WEBPACK FOOTER
// ./adjudicators/index.js
// module id = 92
// module chunks = 0